module.exports = __webpack_public_path__ + "static/media/logo-violet.41813666.svg";